// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ProductionCountryVO } from '@article/model/vo/production-country.vo';

@JsonObject('DrillingholePresetVO')
export class DrillingholePresetVO {
  @JsonProperty('drillingholeArticle', 'ArticleVOConverter', true)
  public drillingholeArticle: ArticleVO = undefined;

  @JsonProperty('distance', 'Number')
  public distance: number = undefined;

  @JsonProperty('initialOffset', 'Number')
  public initialOffset: number = undefined;
}

@JsonObject('DrillingHoleDataVO')
export class DrillingHoleDataVO {
  @JsonProperty('articles', 'ArticleVOsConverter', true)
  public articles: ArticleVO[];

  @JsonProperty('productionCountries', '[ProductionCountryVO]')
  public productionCountries: ProductionCountryVO[];
}
